/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BroadcastScheduleDto } from '../../models/broadcast-schedule-dto';
import { CreateBroadcastScheduleDto } from '../../models/create-broadcast-schedule-dto';

export interface BroadcastScheduleControllerCreateV1$Params {
      body: CreateBroadcastScheduleDto
}

export function broadcastScheduleControllerCreateV1(http: HttpClient, rootUrl: string, params: BroadcastScheduleControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BroadcastScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, broadcastScheduleControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BroadcastScheduleDto>;
    })
  );
}

broadcastScheduleControllerCreateV1.PATH = '/api/v1/broadcast-schedule';
